const LANGUAGE_PRIORITY = {
  3: 3, // French
  2: 2, // English
  1: 1, // Spanish
}

const getLanguagePriority = (learningLanguageId) => {
  return LANGUAGE_PRIORITY[learningLanguageId] || 0
}

const getInitialActiveGroup = (groups = [], currentSelectedGroup = null) => {
  if (groups.length === 0) {
    return null
  }

  if (groups.length === 1) {
    return groups[0]
  }

  if (currentSelectedGroup && currentSelectedGroup.groupId) {
    const currentInSummary = groups.find(
      (g) => g.groupId === currentSelectedGroup.groupId
    )
    if (currentInSummary && (currentInSummary.totalMissionsToDo ?? 0) > 0) {
      return currentInSummary
    }
  }

  const sortedGroups = [...groups].sort((a, b) => {
    const aHasToDo = (a.totalMissionsToDo) > 0 ? 1 : 0
    const bHasToDo = (b.totalMissionsToDo) > 0 ? 1 : 0
    if (aHasToDo !== bHasToDo) {
      return bHasToDo - aHasToDo
    }

    const aLangPriority = getLanguagePriority(a.learningLanguageId)
    const bLangPriority = getLanguagePriority(b.learningLanguageId)
    if (aLangPriority !== bLangPriority) {
      return bLangPriority - aLangPriority
    }

    const aIsMain = a.isMainGroup ? 1 : 0
    const bIsMain = b.isMainGroup ? 1 : 0
    if (aIsMain !== bIsMain) {
      return bIsMain - aIsMain
    }

    const aMissions = a.totalMissionsToDo
    const bMissions = b.totalMissionsToDo
    if (aMissions !== bMissions) {
      return bMissions - aMissions
    }

    return 0
  })

  return sortedGroups[0] || null
}

export { getInitialActiveGroup, getLanguagePriority, LANGUAGE_PRIORITY }
export default getInitialActiveGroup
